export const Disclaimer = () => {
  return (
    <>
      <p>
        Your devices will be processed securely and in compliance with global standards.
      </p>
      <br />
      <p>
        Zolo uses Blancco, the industry-leading data sanitisation solution, certified to meet NIST 800-88, ISO 27040, and Common Criteria standards.
      </p>
      <br />
      <p>
        Zolo is ISO 27001, ISO 14001, AS/NZS 5377, ISO 9001, and ISO 45001 certified.
      </p>
      <br />
      <p>
        <strong>Before we collect:</strong>
      </p>
      <ul>
        <li>Please ensure SIM cards, e-SIMs, software licenses, and manufacturer warranty subscriptions (e.g. AppleCare) are cancelled prior to handover.</li>
      </ul>
      <br />
      <p>
        <strong>Optional additional services</strong>
      </p>
      <p>
        <strong>Available on request:</strong>
      </p>
      <ul>
        <li>SIM/e-SIM checks</li>
        <li>Software license checks</li>
        <li>Warranty assessments</li>
      </ul>
    </>
  );
};

